import React, { useState } from 'react';
import { getUseCaseImageUrl, getUseCaseImageFallbackUrl } from '../services/agentImageService';
import GradientCardImage from './GradientCardImage';

const UseCaseCard = ({ useCase, onSelect, domainName, domainColor }) => {
  const primary = getUseCaseImageUrl(useCase);
  const backup  = getUseCaseImageFallbackUrl(useCase);
  const [src, setSrc]               = useState(primary);
  const [showGradient, setShowGradient] = useState(false);

  const handleError = () => {
    if (src === primary) setSrc(backup);
    else setShowGradient(true);
  };

  return (
    <div
      className="group bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-200 cursor-pointer flex flex-row overflow-hidden min-h-[108px]"
      onClick={() => onSelect('use-case', useCase)}
    >
      {/* Image strip — fills full card height */}
      <div className="w-20 flex-shrink-0 relative overflow-hidden bg-gray-200 self-stretch">
        {showGradient ? (
          <GradientCardImage name={useCase.name} />
        ) : (
          <img
            src={src}
            alt={useCase.name}
            className="absolute inset-0 w-full h-full object-cover saturate-50 group-hover:saturate-100 transition-all duration-300"
            onError={handleError}
          />
        )}
        <div className="absolute inset-0 bg-primary/20" />
      </div>

      {/* Content */}
      <div className="flex flex-col flex-grow min-w-0 p-3 gap-1">
        <h3 className="text-sm font-bold text-gray-900 line-clamp-2 leading-snug">
          {useCase.name}
        </h3>
        <p className="text-xs text-gray-500 line-clamp-2 leading-relaxed flex-grow">
          {useCase.description || 'No description available'}
        </p>
        <div className="flex items-center justify-between pt-1.5">
          <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full ${domainColor}`}>
            {domainName}
          </span>
          <button className="text-xs font-semibold border border-primary/70 text-primary hover:bg-primary hover:text-white hover:border-primary px-3 py-0.5 rounded-full transition-colors duration-150 whitespace-nowrap">
            Open
          </button>
        </div>
      </div>
    </div>
  );
};

export default UseCaseCard;
